import { render, staticRenderFns } from "./editSingle.vue?vue&type=template&id=cbae254e&scoped=true&"
import script from "./editSingle.vue?vue&type=script&lang=js&"
export * from "./editSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbae254e",
  null
  
)

export default component.exports